import { useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import { toast } from 'react-toastify'
import { KTSVG } from '../../../../_metronic/helpers'
import { useChangeDepartmentStatusMutation } from '../../../../services/OrgSettingsApi'
import labelKey from '../../../localization/label.json'
import { useActiveOrInactiveCatagoryBudgetStatusMutation } from '../../../../services/BudgetApi'
type Props = {
    show: boolean
    handleClose: () => void
    data: any
    isChecked: boolean
    refetch: any
}

const ActiveCategoryBudgetConfirmationModal = ({ show, handleClose, data, isChecked, refetch }: Props) => {
    const [updateDepartmentLocationStatus, { data: updateDptLocStatusData, isLoading, isSuccess, isError, error }] = useActiveOrInactiveCatagoryBudgetStatusMutation();
    const handleConfirmation = async () => {
        await updateDepartmentLocationStatus({ catagoryBudgetId: data?.catagoryBudgetId, status: !data?.isActive });
        handleClose();
    };

    useEffect(() => {
        if (isSuccess) {
            const responseData = (updateDptLocStatusData as any)?.message;
            const successMessage = responseData;
            toast.success(successMessage);
            handleClose();
            refetch();
        }
    }, [isSuccess, updateDptLocStatusData]);

    useEffect(() => {
        if (isError && error) {
            let errorMessage: string = 'Something went wrong';

            if ('data' in error && error.data && typeof error.data === 'object' && 'message' in error.data) {
                errorMessage = (error.data as { message: string }).message;
            }
            toast.error(errorMessage);
        }
    }, [isError, error]);
    return (
        <Modal
            aria-hidden='true'
            dialogClassName='modal-dialog modal-md modal-dialog-centered'
            show={show}
            onHide={handleClose}
        >
            <div className='modal-header bg-light py-4'>
                <h2 className='mb-0'>{labelKey.updateCategoryBudgetStatus}</h2>
                {/* begin::Close */}
                <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={handleClose}>
                    <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
                </div>
                {/* end::Close */}
            </div>
            <div className='modal-body py-lg-6 px-lg-6'>
                <p className='fs-5 fw-semibold'>Are you sure you want to Update the category budget Status.
                    {isChecked === true ? <span className='fw-bold fs-5 text-success'> "Active" </span> : <span className='fw-bold fs-5 text-danger'> "In Active" </span>}
                </p>
            </div>
            <div className='modal-footer justify-content-center py-4'>
                <button className='btn btn-light' onClick={handleClose}>{labelKey.cancel}</button>
                <button
                    type='submit'
                    id='kt_sign_up_submit'
                    className='btn btn-primary'
                    onClick={handleConfirmation}
                    disabled={isLoading}
                >
                    {!isLoading && <span className='indicator-label'>{labelKey.yes}</span>}
                    {isLoading && (
                        <span className='indicator-progress' style={{ display: 'block' }}>
                            {labelKey.pleaseWait}{' '}
                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                        </span>
                    )}
                </button>
            </div>
        </Modal>
    )
}

export default ActiveCategoryBudgetConfirmationModal